/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SendingFacilityViewModel } from './sendingFacilityViewModel';
import { DatasetViewModel } from './datasetViewModel';
import { InsuranceCarrierDetailsViewModel } from './insuranceCarrierDetailsViewModel';

export interface InsuranceCarrierLinkDetailsViewModel {
  id?: string;
  datasetId?: string;
  sendingFacilityId?: string;
  financialClassId?: string | null;
  sendingFacilityInsuranceCarrierCode?: string | null;
  sendingFacilityInsuranceCarrierName?: string | null;
  sendingFacilityInsuranceCarrierAddress?: string | null;
  isDeleted?: boolean;
  ignore?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  dataset?: DatasetViewModel;
  insuranceCarrier?: InsuranceCarrierDetailsViewModel;
  readonly address?: string | null;
  readonly name?: string | null;
  readonly code?: string | null;
  sendingFacility?: SendingFacilityViewModel;
  readonly sendingFacilityName?: string | null;
}
